import React, { useState, useEffect } from 'react';
import { genKey } from 'utils/helpers';
import { useTheme } from '@material-ui/core/styles';
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	Label,
	Tooltip,
	ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
	Legend,
    LabelList,
	Bar,
	CartesianGrid,
	BarChart,
	Text,
} from 'recharts';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import _ from 'lodash';

import { Paper, Typography } from '@material-ui/core/';


const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d0eff2", "#81948c", "#dee3a6"];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel1 = (item)=>{

	
    console.log("ITEM", item["Business Unit"].value);
    const radius = item.innerRadius + (item.outerRadius - item.innerRadius) * 0.5;
    const x = item.cx + radius * Math.cos(-item.midAngle * RADIAN);
    const y = item.cy + radius * Math.sin(-item.midAngle * RADIAN);
    
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > item.cx ? "start" : "end"}
        dominantBaseline="central"
       
      >
        {`${(item.percent * 100).toFixed(0)}%`}
       
      </text>
    );
}

const renderCustomizedLabel2 = (item)=>{
	
const { payload } = item;
	const spaces = "    ";
	return (
		<ul>
			{
				payload.map((entry, index) => {
					console.log("ENTRY", entry)
					return(
						<li key={`item-${index}`} style={{"color":`${entry.color}`, "marginRight":"25px"}}>
							<h5>{entry.payload["Business Unit"]}</h5>
							
						</li>
					)
				}
				
				)
			}
		</ul>
	);
}

const renderCustomizedLabel3 = (item)=>{
	
const { payload } = item;
	
	return (
		<>
			{
				payload.map((entry, index) => {
					console.log("ENTRY", entry)
					return(
						<div key={`item-${index}`} style={{"background-color":"white", "padding":"10px","margin": "10px", "border-style": "solid", "border-color":"grey"}}>
							<h5 style={{"color":`${entry.color}`}}>
								{entry.payload["Business Unit"]}
							</h5>
							<label style={{"color":`${entry.color}`}}>
								Acquisition Cost: {entry.payload["Cost"]}
							</label>
							
							
							
						</div>
					)
				}
				
				)
			}
		</>
	);
}


const CustomizedAxisTick = (props) =>{

const {x, y, payload} = props;

return <Text x={x} y={y+10} width={75} textAnchor="middle" verticalAnchor="start">{payload.value}</Text>

};
  
export default function Chart(props) {
	const theme = useTheme();
	const [rows, setRows] = useState([]);
	const [dataPerBu, setDataPerBu] = useState([]);
	const [dataPerDepartment, setDataPerDepartment] = useState([]);

	useEffect(() => {
		
		if(props.data){
			console.log(props.data)
			const tempItems = [];
			const tempMonths = [1,2,3,4,5,6,7,8,9,10,11,12];
			const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
			for(let month of tempMonths){
				const tempRows = props.data.filter((item) => item.month === month);
				if(tempRows.length === 0){
					tempItems.push({
						
						Month: months[month],
						Total : 0,
						"Total Count": 0
					});
				}else{
					tempItems.push({
						
						Month: months[tempRows[0].month],
						Total: tempRows[0].total,
						"Total Count": tempRows[0].totalCount
					});
				}

			}

			let temp_per_bu = [];

			let data_total_cost = props.rows.reduce((a, b) => a + b.acqCost, 0);

			if(localStorage.getItem('businessUnits')){
				let items = JSON.parse(localStorage.getItem('businessUnits'));
				

				for(let bu of items){

					console.log("BU", bu.value.toString().toLowerCase());
					
					const tempRows = props.rows.filter((i) => i.businessUnit.toLowerCase() === bu.value.toLowerCase());

					const tempCost = tempRows.reduce((a, b) => a + b.acqCost, 0);
					const tempPercentage = (tempCost / data_total_cost) * 100;
					const tempTotalItems = tempRows.length;
					
					temp_per_bu.push({
						"Business Unit": bu.value,
						"Cost": tempCost,
						"Total Assets": tempTotalItems,
						"Contribution": tempPercentage
					});

					
					
				}
				setDataPerBu(temp_per_bu);
			}

			let temp_per_dept = [];
			if(localStorage.getItem('depts')){
				let items = JSON.parse(localStorage.getItem('depts'));
				for(let dept of items){
					const tempRows = props.rows.filter((i) => i.deptName.toLowerCase() === dept.value.toLowerCase());

					const tempCost = tempRows.reduce((a, b) => a + b.acqCost, 0);
					const tempPercentage = (tempCost / data_total_cost) * 100;
					const tempTotalItems = tempRows.length;
					
					temp_per_dept.push({
						"Department": dept.value,
						"Cost": tempCost,
						"Total Assets": tempTotalItems,
						"Contribution": tempPercentage
					});
				}
				setDataPerDepartment(temp_per_dept);
			}

			console.log(tempItems);

			setRows(tempItems);

		}



		return () => {
		
		}
	}, [props.data])

	return (
		<React.Fragment>
			{/* <Title>Processed IRR</Title>
			<ResponsiveContainer>
				<LineChart
					data={rows}
					margin={{
						top: 16,
						right: 16,
						bottom: 0,
						left: 24,
					}}
				>
					<XAxis dataKey="Month" stroke={theme.palette.text.secondary} />
					<YAxis stroke={theme.palette.text.secondary}>
						<Label
							angle={270}
							position="left"
							style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
						>
							FAMAS Count
						</Label>
					</YAxis>
					<Tooltip />
					<Line
						type="monotone"
						dataKey="Total Count"
						stroke={theme.palette.primary.main}
						activeDot={{ r: 8 }}
					/>
				</LineChart>
			</ResponsiveContainer> */}

			
			<Paper style={{"margin":"10px"}}>
			<Typography component="h2" variant="h6" color="primary" gutterBottom style={{padding:"10px"}}>
				Per Business Unit
			</Typography>
			<div style = {{height:"400px", width:"800px"}}>
				<ResponsiveContainer width="100%" height="100%">
				<PieChart width={400} height={400}>
					<Pie
						labelLine={false}
						dataKey="Cost"
						isAnimationActive={false}
						data={dataPerBu}
						cx="200"
						cy="200"
						fill="#8884d8"
						label = {renderCustomizedLabel1}
					>
						{dataPerBu.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
						))}
					</Pie>
					<Tooltip content={renderCustomizedLabel3}/>
					<Legend content={renderCustomizedLabel2} layout='bottom' verticalAlign="bottom" align="right"/>
				</PieChart>
				</ResponsiveContainer>
				
			</div>
			</Paper>

            <Paper style={{"margin":"10px"}}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>Business Unit</TableCell>
							<TableCell>Cost</TableCell>
							<TableCell>Number of Assets</TableCell>
							<TableCell> % Contribution</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
					{
						dataPerBu && dataPerBu.length > 0 ? 

						dataPerBu.map((row) => (
							<TableRow key={`${genKey()}_row`}>
								<TableCell>{row["Business Unit"]}</TableCell>
								<TableCell align="right">{row["Cost"].toLocaleString()}</TableCell>
								<TableCell>{row["Total Assets"]}</TableCell>
								<TableCell>{Math.round(row["Contribution"])}</TableCell>
							</TableRow>))
							
						:
							null
					}
					{
						<TableRow key={`${genKey()}_row`}>
							<TableCell align="right">TOTAL</TableCell>
							<TableCell align="right">{Math.round(dataPerBu.reduce((a, b) => a + b["Cost"], 0)).toLocaleString()}</TableCell>
							<TableCell>{Math.round(dataPerBu.reduce((a, b) => a + b["Total Assets"], 0))}</TableCell>
							<TableCell>{Math.round(dataPerBu.reduce((a, b) => a + b["Contribution"], 0))}</TableCell>
						</TableRow>
					}
					</TableBody>
				</Table>
			</Paper>

			<Paper style={{"margin":"10px"}}>
				<div style={{ width: "100%", overflow: "auto", display: "flex" }}>
				<BarChart
                      width={((dataPerDepartment.length || 1) * 200)}
                      height={500}
                      data={dataPerDepartment}
                      margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 5
                      }}
                      
                      >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="Department" interval={0}  tick={<CustomizedAxisTick />} height={100}/>
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="Cost" stackId="a" fill="#0088FE" barSize={200}>
                          <LabelList
                          dataKey="Cost"
                          fill="#FFF"
                          position="center"
                          />
                      </Bar>
                      <Bar dataKey="Total Assets" stackId="b" fill="#82ca9d" barSize={200}>
                          <LabelList
                          dataKey="Total Assets"
                          fill="#FFF"
                          position="center"
                          />
                      </Bar>
                  </BarChart>
				</div>
			</Paper>
		</React.Fragment>
	);
}
